import React from 'react';
import { StylesProvider, StyleSheet } from '@rexlabs/styling';
import CoreDateInput from './core';
var navigationButtons = {
  borderStyle: 'solid',
  borderWidth: function borderWidth(_ref) {
    var token = _ref.token;
    return token('dateInput.datePicker.navigation.button.border.width', 0);
  },
  borderColor: function borderColor(_ref2) {
    var token = _ref2.token;
    return token('dateInput.datePicker.navigation.button.border.color', token('palette.grey.400', 'grey'));
  },
  color: function color(_ref3) {
    var token = _ref3.token;
    return token('dateInput.datePicker.navigation.button.border.color', token('dateInput.datePicker.navigation.button.border.color', token('palette.grey.400', 'grey')));
  },
  fontSize: function fontSize(_ref4) {
    var token = _ref4.token;
    return token('dateInput.datePicker.navigation.button.font.size', token('typography.size.s', '1.2rem'));
  }
};
var overrides = {
  TextInput: StyleSheet({
    wrapper: {
      position: 'relative'
    }
  }),
  DayPickerNavigation: StyleSheet({
    prev: navigationButtons,
    next: navigationButtons
  }),
  DayPicker: StyleSheet({
    weekHeader: {
      fontSize: function fontSize(_ref5) {
        var token = _ref5.token;
        return token('dateInput.datePicker.weekHeader.font.size', token('typography.size.xs', '1rem'));
      },
      color: function color(_ref6) {
        var token = _ref6.token;
        return token('dateInput.datePicker.weekHeader.color', token('palette.grey.400', 'grey'));
      },
      top: '5.8rem'
    },
    container: {
      boxShadow: function boxShadow(_ref7) {
        var token = _ref7.token;
        return token('dateInput.datePicker.shadow', token('shadow.drop.light', '0 .2rem .6rem rgba(0,0,0,0.05)'));
      },
      borderRadius: function borderRadius(_ref8) {
        var token = _ref8.token;
        return "".concat(token('dateInput.datePicker.border.radius', token('border.radius.none', 0)), " !important");
      },
      borderColor: function borderColor(_ref9) {
        var token = _ref9.token;
        return token('dateInput.datePicker.background', 'transparent');
      },
      zIndex: function zIndex(_ref10) {
        var token = _ref10.token;
        return token('dateInput.datePicker.zIndex', 10);
      }
    }
  }),
  CalendarMonth: StyleSheet({
    title: {
      fontSize: function fontSize(_ref11) {
        var token = _ref11.token;
        return token('dateInput.datePicker.title.font.size', token('typography.size.l', '1.8rem'));
      },
      color: function color(_ref12) {
        var token = _ref12.token;
        return token('dateInput.datePicker.title.color', token('color.textStyle.body.default', 'black'));
      }
    }
  }),
  CalendarDay: StyleSheet({
    container: {
      fontSize: function fontSize(_ref13) {
        var token = _ref13.token;
        return token('dateInput.datePicker.day.font.size', token('typography.size.s', '1.2rem'));
      },
      color: function color(_ref14) {
        var token = _ref14.token;
        return token('dateInput.datePicker.day.color', token('color.textStyle.body.default', 'black'));
      },
      borderColor: function borderColor(_ref15) {
        var token = _ref15.token;
        return token('dateInput.datePicker.day.border.color', token('palette.grey.100', 'lightgrey'));
      },
      borderWidth: function borderWidth(_ref16) {
        var token = _ref16.token;
        return token('dateInput.datePicker.day.border.width', token('border.width.thin', '.1rem'));
      },
      '&:hover': {
        borderColor: function borderColor(_ref17) {
          var token = _ref17.token;
          return token('dateInput.datePicker.day.hover.border.color', token('palette.grey.100', 'lightgrey'));
        },
        background: function background(_ref18) {
          var token = _ref18.token;
          return token('dateInput.datePicker.day.hover.background', token('palette.grey.100', 'lightgrey'));
        },
        color: function color(_ref19) {
          var token = _ref19.token;
          return token('dateInput.datePicker.day.hover.color', token('color.textStyle.body.default', 'black'));
        }
      }
    },
    today: {
      color: function color(_ref20) {
        var token = _ref20.token;
        return token('dateInput.datePicker.day.today.color', token('color.textStyle.body.default', 'black'));
      },
      fontWeight: function fontWeight(_ref21) {
        var token = _ref21.token;
        return token('dateInput.datePicker.day.today.font.weight', token('typography.weight.bold', 'bold'));
      },
      borderColor: function borderColor(_ref22) {
        var token = _ref22.token;
        return token('dateInput.datePicker.day.today.border.color', token('dateInput.datePicker.day.border.color', token('palette.grey.100', 'lightgrey')));
      }
    },
    selected: {
      '&, &:hover': {
        color: function color(_ref23) {
          var token = _ref23.token;
          return token('dateInput.datePicker.day.selected.color', token('color.primary.idle.contrast', 'white'));
        },
        fontWeight: function fontWeight(_ref24) {
          var token = _ref24.token;
          return token('dateInput.datePicker.day.selected.font.weight', token('typography.weight.bold', 'bold'));
        },
        borderColor: function borderColor(_ref25) {
          var token = _ref25.token;
          return token('dateInput.datePicker.day.selected.border.color', token('dateInput.datePicker.day.border.color', token('color.primary.idle.default', 'purple')));
        },
        background: function background(_ref26) {
          var token = _ref26.token;
          return token('dateInput.datePicker.day.selected.background', token('color.primary.idle.default', 'purple'));
        }
      }
    },
    blocked: {
      '&, &:hover': {
        color: function color(_ref27) {
          var token = _ref27.token;
          return token('dateInput.datePicker.day.blocked.color', token('palette.grey.100', 'lightgrey'));
        }
      }
    }
  })
};

function DatePicker(props) {
  return /*#__PURE__*/React.createElement(StylesProvider, {
    components: overrides
  }, /*#__PURE__*/React.createElement(CoreDateInput, props));
}

export default DatePicker;